import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <main className="w-full  flex flex-col items-center justify-center bg-gray-100 text-gray-800 p-6">
      <h1 className="text-6xl font-bold text-red-500 mb-4">404</h1>
      <p className="text-lg md:text-xl font-semibold mb-4">
        Oops! Page not found.
      </p>
      <p className="text-gray-600">
        The page you’re looking for doesn’t exist. Go back to{' '}
        <Link to="/" className="text-blue-600 hover:underline">
          our homepage
        </Link>
        .
      </p>
    </main>
  );
}

export default NotFound;
